import React from 'react';

const LoadingDot = ({label}) => {
    return (
        <div className='flex space-x-1 text-white justify-center items-center'>
            <div className="mr-2">{label}</div>
            <div className='h-1 w-1 bg-white rounded-full animate-bounce [animation-delay:-0.3s]'></div>
            <div className='h-1 w-1 bg-white rounded-full animate-bounce [animation-delay:-0.15s]'></div>
            <div className='h-1 w-1 bg-white rounded-full animate-bounce'></div>
        </div>
    )
}

export default LoadingDot